function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#Group_307_svg__filter0_dd)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M77.01 85.778v25.296l22.01 12.896V98.509l-22.01-12.73z",
  fill: "url(#Group_307_svg__paint0_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M121.029 85.778v25.296L99.02 123.97V98.509l22.009-12.73z",
  fill: "url(#Group_307_svg__paint1_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M77.01 85.78l22.01-12.731 22.009 12.73-22.01 12.73L77.01 85.78z",
  fill: "url(#Group_307_svg__paint2_linear)"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#Group_307_svg__filter1_dd)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32.99 85.777v25.296L55 123.968v-25.46L32.99 85.776z",
  fill: "url(#Group_307_svg__paint3_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M77.01 85.777v25.296L55 123.968v-25.46l22.01-12.731z",
  fill: "url(#Group_307_svg__paint4_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.99 85.778L55 73.048l22.01 12.73L55 98.508l-22.01-12.73z",
  fill: "url(#Group_307_svg__paint5_linear)"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#Group_307_svg__filter2_dd)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M55 98.506v25.296l22.01 12.896v-25.461L55 98.507z",
  fill: "url(#Group_307_svg__paint6_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M99.02 98.506v25.296l-22.01 12.896v-25.461l22.01-12.73z",
  fill: "url(#Group_307_svg__paint7_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55 98.507l22.01-12.73 22.01 12.73-22.01 12.731L55 98.508z",
  fill: "url(#Group_307_svg__paint8_linear)"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#Group_307_svg__filter3_dd)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M55 48.192v25.295l22.009 12.896v-25.46l-22.01-12.731z",
  fill: "url(#Group_307_svg__paint9_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M99.019 48.192v25.295l-22.01 12.896v-25.46l22.01-12.731z",
  fill: "url(#Group_307_svg__paint10_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55 48.193l22.009-12.73 22.01 12.73-22.01 12.73-22.01-12.73z",
  fill: "url(#Group_307_svg__paint11_linear)"
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M32.99 60.923v25.296L55 99.115V73.653l-22.01-12.73z",
  fill: "url(#Group_307_svg__paint12_linear)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M77.01 60.923v25.296L55 99.115V73.653l22.01-12.73z",
  fill: "url(#Group_307_svg__paint13_linear)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M32.99 60.924L55 48.194l22.01 12.73L55 73.654l-22.01-12.73z",
  fill: "url(#Group_307_svg__paint14_linear)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M77.008 60.924v25.295l22.01 12.896v-25.46l-22.01-12.731z",
  fill: "url(#Group_307_svg__paint15_linear)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M121.028 60.924v25.295l-22.01 12.896v-25.46l22.01-12.731z",
  fill: "url(#Group_307_svg__paint16_linear)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M77.008 60.925l22.01-12.73 22.009 12.73-22.009 12.73-22.01-12.73z",
  fill: "url(#Group_307_svg__paint17_linear)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M55 73.652v25.296l22.01 12.896V86.383L55 73.653z",
  fill: "url(#Group_307_svg__paint18_linear)"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M99.02 73.652v25.296l-22.01 12.896V86.383l22.01-12.73z",
  fill: "url(#Group_307_svg__paint19_linear)"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M55 73.653l22.01-12.73 22.01 12.73-22.01 12.73L55 73.654z",
  fill: "url(#Group_307_svg__paint20_linear)"
});

var _ref15 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#Group_307_svg__filter4_d)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M115.765 37.139l-10.734-6.29V18.517l10.734 6.208V37.14z",
  fill: "url(#Group_307_svg__paint21_linear)",
  stroke: "url(#Group_307_svg__paint22_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M116.765 24.725l10.734-6.209V30.85l-10.734 6.29V24.725z",
  fill: "url(#Group_307_svg__paint23_linear)",
  stroke: "url(#Group_307_svg__paint24_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M116.265 23.86l-10.735-6.21 10.735-6.21 10.736 6.21-10.736 6.21z",
  fill: "url(#Group_307_svg__paint25_linear)",
  stroke: "url(#Group_307_svg__paint26_linear)"
}));

var _ref16 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#Group_307_svg__filter5_d)",
  strokeWidth: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M50.952 15.473l-6.347-3.72V4.462l6.347 3.671v7.34z",
  fill: "url(#Group_307_svg__paint27_linear)",
  stroke: "url(#Group_307_svg__paint28_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.452 8.132L57.8 4.461v7.293l-6.347 3.719V8.131z",
  fill: "url(#Group_307_svg__paint29_linear)",
  stroke: "url(#Group_307_svg__paint30_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.203 7.7l-6.348-3.672L51.203.356l6.348 3.672-6.348 3.671z",
  fill: "url(#Group_307_svg__paint31_linear)",
  stroke: "url(#Group_307_svg__paint32_linear)"
}));

var _ref17 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#Group_307_svg__filter6_d)",
  strokeWidth: 0.7
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.15 53.233l-9.316-5.458V37.07l9.316 5.389v10.774z",
  fill: "url(#Group_307_svg__paint33_linear)",
  stroke: "url(#Group_307_svg__paint34_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.85 42.459l9.316-5.389v10.705l-9.316 5.458V42.459z",
  fill: "url(#Group_307_svg__paint35_linear)",
  stroke: "url(#Group_307_svg__paint36_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.5 41.853l-9.316-5.39 9.317-5.388 9.317 5.389-9.317 5.389z",
  fill: "url(#Group_307_svg__paint37_linear)",
  stroke: "url(#Group_307_svg__paint38_linear)"
}));

var _ref18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "Group_307_svg__paint0_linear",
  x1: 88.516,
  y1: 92.034,
  x2: 88.516,
  y2: 120.223,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.153,
  stopColor: "#6E36E5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7535FD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Group_307_svg__paint1_linear",
  x1: 110.377,
  y1: 93.184,
  x2: 110.377,
  y2: 116.196,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8146FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.979,
  stopColor: "#7B42F4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Group_307_svg__paint2_linear",
  x1: 97.145,
  y1: 74.775,
  x2: 98.871,
  y2: 98.362,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9664FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#874FFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Group_307_svg__paint3_linear",
  x1: 44.497,
  y1: 92.032,
  x2: 44.497,
  y2: 120.222,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.153,
  stopColor: "#6E36E5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7535FD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Group_307_svg__paint4_linear",
  x1: 66.358,
  y1: 93.183,
  x2: 66.358,
  y2: 116.195,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8146FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.979,
  stopColor: "#7B42F4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Group_307_svg__paint5_linear",
  x1: 53.126,
  y1: 74.773,
  x2: 54.852,
  y2: 98.361,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9664FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#874FFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Group_307_svg__paint6_linear",
  x1: 66.506,
  y1: 104.762,
  x2: 66.506,
  y2: 132.951,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.153,
  stopColor: "#6E36E5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7535FD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Group_307_svg__paint7_linear",
  x1: 88.368,
  y1: 105.912,
  x2: 88.368,
  y2: 128.924,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8146FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.979,
  stopColor: "#7B42F4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Group_307_svg__paint8_linear",
  x1: 75.136,
  y1: 87.503,
  x2: 76.862,
  y2: 111.09,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9664FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#874FFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Group_307_svg__paint9_linear",
  x1: 66.505,
  y1: 54.447,
  x2: 66.505,
  y2: 82.636,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.153,
  stopColor: "#6E36E5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7535FD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Group_307_svg__paint10_linear",
  x1: 88.367,
  y1: 55.598,
  x2: 88.367,
  y2: 78.609,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8146FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.979,
  stopColor: "#7B42F4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Group_307_svg__paint11_linear",
  x1: 75.135,
  y1: 37.188,
  x2: 76.861,
  y2: 60.775,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9664FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#874FFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Group_307_svg__paint12_linear",
  x1: 44.496,
  y1: 67.178,
  x2: 44.496,
  y2: 95.368,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.153,
  stopColor: "#6E36E5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7535FD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Group_307_svg__paint13_linear",
  x1: 66.357,
  y1: 68.329,
  x2: 66.357,
  y2: 91.341,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8146FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.979,
  stopColor: "#7B42F4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Group_307_svg__paint14_linear",
  x1: 53.126,
  y1: 49.919,
  x2: 54.852,
  y2: 73.507,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9664FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#874FFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Group_307_svg__paint15_linear",
  x1: 88.514,
  y1: 67.179,
  x2: 88.514,
  y2: 95.368,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.153,
  stopColor: "#6E36E5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7535FD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Group_307_svg__paint16_linear",
  x1: 110.376,
  y1: 68.33,
  x2: 110.376,
  y2: 91.341,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8146FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.979,
  stopColor: "#7B42F4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Group_307_svg__paint17_linear",
  x1: 97.144,
  y1: 49.92,
  x2: 98.87,
  y2: 73.507,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9664FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#874FFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Group_307_svg__paint18_linear",
  x1: 66.506,
  y1: 79.907,
  x2: 66.506,
  y2: 108.097,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.153,
  stopColor: "#6E36E5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7535FD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Group_307_svg__paint19_linear",
  x1: 88.368,
  y1: 81.058,
  x2: 88.368,
  y2: 104.07,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8146FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.979,
  stopColor: "#7B42F4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Group_307_svg__paint20_linear",
  x1: 75.136,
  y1: 62.649,
  x2: 76.862,
  y2: 86.236,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9664FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#874FFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Group_307_svg__paint21_linear",
  x1: 110.665,
  y1: 20.985,
  x2: 110.665,
  y2: 36.014,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.153,
  stopColor: "#DCDBDF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D1CDD6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Group_307_svg__paint22_linear",
  x1: 113,
  y1: 30.25,
  x2: 104.531,
  y2: 32.75,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E76262"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.345,
  stopColor: "#fff",
  stopOpacity: 0.31
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Group_307_svg__paint23_linear",
  x1: 122.32,
  y1: 21.598,
  x2: 122.32,
  y2: 33.867,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D9D3DD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.979,
  stopColor: "#C1C0C6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Group_307_svg__paint24_linear",
  x1: 130.25,
  y1: 22,
  x2: 126.625,
  y2: 34.75,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF5454"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.763,
  stopColor: "#FF5454",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.942,
  stopColor: "#fff",
  stopOpacity: 0.19
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Group_307_svg__paint25_linear",
  x1: 115.266,
  y1: 11.783,
  x2: 116.186,
  y2: 24.359,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EEEAF5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DAD6E1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Group_307_svg__paint26_linear",
  x1: 116.265,
  y1: 10.863,
  x2: 116.265,
  y2: 20.625,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF5454"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.926,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Group_307_svg__paint27_linear",
  x1: 47.934,
  y1: 5.973,
  x2: 47.934,
  y2: 14.743,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.153,
  stopColor: "#DCDBDF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D1CDD6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Group_307_svg__paint28_linear",
  x1: 51.202,
  y1: 8.25,
  x2: 44.355,
  y2: 13,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DE4141"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.84,
  stopColor: "#fff",
  stopOpacity: 0.297
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Group_307_svg__paint29_linear",
  x1: 54.735,
  y1: 6.331,
  x2: 54.735,
  y2: 13.49,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D9D3DD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.979,
  stopColor: "#C1C0C6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Group_307_svg__paint30_linear",
  x1: 54.626,
  y1: 4.027,
  x2: 54.626,
  y2: 15.909,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0.286
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.503,
  stopColor: "#FF4D4D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Group_307_svg__paint31_linear",
  x1: 50.62,
  y1: 0.604,
  x2: 51.157,
  y2: 7.942,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EEEAF5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DAD6E1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Group_307_svg__paint32_linear",
  x1: 51.203,
  y1: 0.067,
  x2: 51.203,
  y2: 7.988,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE5D5D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0.49
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Group_307_svg__paint33_linear",
  x1: 13.72,
  y1: 39.31,
  x2: 13.72,
  y2: 52.139,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.153,
  stopColor: "#DCDBDF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D1CDD6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Group_307_svg__paint34_linear",
  x1: 16.25,
  y1: 42.25,
  x2: 5,
  y2: 47,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E64949"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.578,
  stopColor: "#fff",
  stopOpacity: 0.422
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5151",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Group_307_svg__paint35_linear",
  x1: 23.669,
  y1: 39.834,
  x2: 23.669,
  y2: 50.306,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D9D3DD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.979,
  stopColor: "#C1C0C6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Group_307_svg__paint36_linear",
  x1: 18.5,
  y1: 40.75,
  x2: 18.5,
  y2: 51.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF5858"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.502,
  stopColor: "#FF5858",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0.29
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Group_307_svg__paint37_linear",
  x1: 17.648,
  y1: 31.456,
  x2: 18.433,
  y2: 42.19,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EEEAF5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DAD6E1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Group_307_svg__paint38_linear",
  x1: 18.501,
  y1: 31.5,
  x2: 18.501,
  y2: 41,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.046,
  stopColor: "#FF6D6D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.464,
  stopColor: "#fff",
  stopOpacity: 0.599
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5A5A",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("filter", {
  id: "Group_307_svg__filter0_dd",
  x: 69.01,
  y: 72.049,
  width: 60.02,
  height: 67.921,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.341176 0 0 0 0 0.152941 0 0 0 0 0.741176 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.203922 0 0 0 0 0.0823529 0 0 0 0 0.462745 0 0 0 0.3 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_dropShadow",
  result: "effect2_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect2_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "Group_307_svg__filter1_dd",
  x: 24.991,
  y: 72.047,
  width: 60.019,
  height: 67.921,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.341176 0 0 0 0 0.152941 0 0 0 0 0.741176 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.203922 0 0 0 0 0.0823529 0 0 0 0 0.462745 0 0 0 0.3 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_dropShadow",
  result: "effect2_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect2_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "Group_307_svg__filter2_dd",
  x: 47.001,
  y: 84.777,
  width: 60.019,
  height: 67.921,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.341176 0 0 0 0 0.152941 0 0 0 0 0.741176 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.203922 0 0 0 0 0.0823529 0 0 0 0 0.462745 0 0 0 0.3 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_dropShadow",
  result: "effect2_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect2_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "Group_307_svg__filter3_dd",
  x: 46.999,
  y: 34.462,
  width: 60.019,
  height: 67.921,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.341176 0 0 0 0 0.152941 0 0 0 0 0.741176 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.203922 0 0 0 0 0.0823529 0 0 0 0 0.462745 0 0 0 0.3 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_dropShadow",
  result: "effect2_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect2_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "Group_307_svg__filter4_d",
  x: 96.531,
  y: 10.863,
  width: 39.469,
  height: 43.148,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.65175 0 0 0 0 0.647361 0 0 0 0 0.658333 0 0 0 0.24 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "Group_307_svg__filter5_d",
  x: 36.355,
  y: 0.067,
  width: 29.695,
  height: 31.842,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.65175 0 0 0 0 0.647361 0 0 0 0 0.658333 0 0 0 0.24 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "Group_307_svg__filter6_d",
  x: 0.484,
  y: 30.671,
  width: 36.033,
  height: 39.173,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.65175 0 0 0 0 0.647361 0 0 0 0 0.658333 0 0 0 0.24 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

var SvgQuick = function SvgQuick(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 153,
    viewBox: "0 0 136 153",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQuick, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/quick.01f9fd59.svg";
export { ForwardRef as ReactComponent };